import React from 'react';
import Moment from 'moment';
import { Table, Thead, Tbody, Td, Tr } from 'react-super-responsive-table';
import StaticCurrencyInput from '../currencyinput/static';

// eslint-disable-next-line no-unused-vars
import headertable from './headertable.css';

const HeaderTable = props => {
  const { startDate, finalDate, amount } = {
    ...props,
  };

  const formattedIncurredDate = new Moment(startDate).format('DD/MM/YYYY');
  const formattedFinalDate = new Moment(finalDate).format('DD/MM/YYYY');
  return (
    <>
      <Table className="heading-table">
        <Thead>
          <Tr className="heading-table__row heading-table__row--heading">
            <Td className="heading-table__col heading-table__col--heading">
              Incurred Date
            </Td>
            <Td className="heading-table__col heading-table__col--heading">
              Final Date
            </Td>
            <Td
              className="heading-table__col heading-table__col--heading"
              id="incurred-amount-title"
            >
              Incurred Amount
            </Td>
          </Tr>
        </Thead>
        <Tbody>
          <Tr className="heading-table__row heading-table__row--body">
            <Td className="heading-table__col heading-table__col--body">
              {formattedIncurredDate}
            </Td>
            <Td className="heading-table__col heading-table__col--body">
              {formattedFinalDate}
            </Td>
            <Td className="heading-table__col heading-table__col--body">
              <StaticCurrencyInput
                value={amount}
                label="incurred-amount-title"
              />
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </>
  );
};

export default HeaderTable;
